<xpo-shell class="main-shell">
  <xpo-header-app-name>Edge</xpo-header-app-name>
  <xpo-header-sub-app-name>{{ title }}</xpo-header-sub-app-name>
  <xpo-header-navigation>
    <button *ngFor="let route of routes" [routerLink]="route.path" routerLinkActive="xpo-selected">
      {{ route.label }}
    </button>
  </xpo-header-navigation>
  <xpo-header-utilities-actions>
    <xpo-auth-app-switcher [applications]="switcherApps$ | async"></xpo-auth-app-switcher>
    <xpo-account-popover *ngIf="accountPopoverProfileConfig" [config]="accountPopoverProfileConfig">
    </xpo-account-popover>
  </xpo-header-utilities-actions>
  <router-outlet></router-outlet>
</xpo-shell>
<app-footer [buildVersion]="build" (releaseNotes)="releaseNotesSelectedAndOpen()"></app-footer>
<app-notification></app-notification>
